import { BalancedMasonryGrid as MasonryGrid } from "@masonry-grid/vanilla"; // Import corretto

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.getElementById("grid");

  grid.classList.remove("hidden");

  new MasonryGrid(grid);
});
